import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M6.603.778a.423.423 0 0 1 .794 0l1.625 4.095a.43.43 0 0 0 .363.277l4.219.354c.381.032.536.53.245.792l-3.214 2.886a.46.46 0 0 0-.139.446l.982 4.315c.09.39-.316.699-.642.49L7.224 12.12a.41.41 0 0 0-.448 0l-3.612 2.313c-.326.209-.731-.1-.642-.49l.982-4.315a.46.46 0 0 0-.139-.446L.151 6.296c-.29-.261-.136-.76.245-.792l4.219-.354c.16-.014.3-.12.363-.277z" }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "star"}) } }